var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-layout"},[_c('div',{staticClass:"sticky-top"},[_c('Header'),_vm._v(" "),_c('top-menu')],1),_vm._v(" "),_c('div',[_c('child')],1),_vm._v(" "),_c('new-order-modal',{on:{"closeModal":_vm.closeNewOrderModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }